<template>
  <div class="px-4 rounded flex flex-col relative">
    <div
      class="py-4 border-b bg-grey-lighter font-medium flex flex-1 flex-row"
    >
      <div class="w-full flex">
        <div class="w-5/6 flex">
          <div class="w-1/3 ml-2">Day</div>
          <div class="w-1/3 ml-2">Start Time</div>
          <div class="w-1/3 ml-2">End Time</div>
        </div>
        <div class="w-1/6 flex">
          <div class="w-full text-center">Actions</div>
        </div>
      </div>
    </div>
    <div class="mx-2 flex flex-col">
      <schedule-row
        v-for="(schedule, index) in schedules"
        :key="index"
        :schedule-details="schedule"
        :schedule-length="schedules.length"
        :overlapped-days="overlappedDays"
        @deleteRow="deleteScheduleRowInfo"
        @updateSchedules="updateSchedules"
        @emptyOverlappedDays="emptyOverlappedDays"
      />
    </div>

    <pt-button
      class="mt-4"
      variant="secondary-outline"
      size="sm"
      @action="addLine"
    >
      Add Line
    </pt-button>
    <div class="add-edit-schedule-content-spacer" />
  </div>
</template>

<script>
import ScheduleRow from '@components/schedule/schedule-row.vue';
import groupByStartEndTime from '@utils/group-by-start-end-time';

export default {
  name: 'SchedulesList',
  components: {
    ScheduleRow,
  },
  props: {
    dateSchedules: {
      type: Array,
      default: () => [],
    },
    overlappedDays: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      index: 1,
      schedules: [
        {
          id: 1,
          opening_time: '00:00:00',
          closing_time: '11:59:59',
          days: [],
        },
      ],
      date: new Date(),
      disabledDates: {
        to: new Date(),
      },
    };
  },
  watch: {
    dateSchedules: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.schedules = groupByStartEndTime(newVal);
        }
        this.updateSchedules(this.schedules);
      },
      immediate: true,
    },
  },
  methods: {
    addLine() {
      this.$sendEvent('RS_AddScheduleRow');
      let schedule = {
        id: this.index,
        opening_time: '00:00:00',
        closing_time: '23:59:59',
        days: [],
      };
      this.schedules.push(schedule);
      this.index++;
      this.updateSchedules(schedule);
    },
    deleteScheduleRowInfo(index) {
      this.schedules = this.schedules.filter(element => element.id !== index);
      this.$emit('deleteSchedule', index);
    },
    updateSchedules(schedule) {
      this.$emit('updateSchedules', schedule);
    },
    emptyOverlappedDays() {
      this.$emit('emptyOverlappedDays');
    },
  },
};
</script>
